module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('main-banner', {
    attrs: {
      "image": 'src/assets/images/' + _vm.image
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "blue--text mt-5"
  }, [_vm._v(_vm._s(_vm.$t('pages.clients.pharmacies.title')))]), _vm._v(" "), _c('div', {
    staticClass: "mt-2 section-content",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.clients.pharmacies.about'))
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "blue--text mt-5"
  }, [_vm._v(_vm._s(_vm.$t('pages.clients.pharmacies.products.title')))]), _vm._v(" "), _c('div', {
    staticClass: "mt-2 section-content",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.clients.pharmacies.products.content'))
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "row wrap mt-5"
  }, _vm._l((_vm.products), function(item) {
    return _c('v-flex', {
      key: item,
      staticClass: "pa-3",
      attrs: {
        "xs12": "",
        "lg6": ""
      }
    }, [_c('v-card', [_c('v-card-title', {
      class: 'white--text blue darken-' + (_vm.index + 1),
      attrs: {
        "primary-title": ""
      }
    }, [_c('div', [_c('div', {
      staticClass: "headline"
    }, [_vm._v(_vm._s(_vm.$t('pages.clients.pharmacies.products.items.' + item.name + '.name')))])])]), _vm._v(" "), _c('v-card-text', {
      staticClass: "text-xs-center"
    }, [_c('video', {
      attrs: {
        "width": "90%",
        "height": "auto",
        "controls": ""
      }
    }, [_c('source', {
      attrs: {
        "src": 'src/assets/video/' + item.video,
        "type": "video/mp4"
      }
    }), _vm._v("\n            Your browser does not support the video tag.\n          ")])]), _vm._v(" "), _c('v-card-row', {
      staticClass: "blue lighten-1"
    }, [_c('v-card-text', [_c('span', {
      staticClass: "white--text"
    }, [_vm._v(_vm._s(_vm.$t('pages.clients.pharmacies.products.items.' + item.name + '.description')))])])], 1)], 1)], 1)
  }), 1), _vm._v(" "), _c('h2', {
    staticClass: "blue--text mt-5"
  }, [_vm._v(_vm._s(_vm.$t('pages.clients.pharmacies.cooperation.title')))]), _vm._v(" "), _c('div', {
    staticClass: "mt-2 section-content"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.clients.pharmacies.cooperation.content'))
    }
  }), _vm._v(" "), _c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('pages.clients.pharmacies.cooperation.voivodships')))])]), _vm._v(" "), _c('v-layout', {
    staticClass: "row wrap"
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "lg8": "",
      "offset-lg2": ""
    }
  }, [_c('v-layout', {
    staticClass: "row wrap mt-2"
  }, _vm._l((_vm.reps), function(item) {
    return _c('v-flex', {
      key: item,
      attrs: {
        "xs12": "",
        "lg6": ""
      }
    }, [_c('div', [_c('strong', [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.phone))]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((item.voivodships), function(voivodship) {
      return _c('div', {
        key: voivodship
      }, [_vm._v("\n              " + _vm._s(voivodship) + "\n            ")])
    }), _vm._v(" "), _c('br')], 2)
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.clients.pharmacies.cooperation.contact'))
    }
  }), _vm._v(" "), _c('div', [_c('v-btn', {
    attrs: {
      "block": "",
      "href": "/download/raportownik.zip"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('pages.clients.pharmacies.cooperation.raportownik')) + "\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65d76a08"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Pharmacies.vue
// module id = 439
// module chunks = 0